import { animate, stagger } from 'animejs';

const fadeOut = (hotspots, onComplete) => {
  if (!hotspots.length) {
    if (onComplete) onComplete();
    return;
  }
  animate(hotspots, {
    ease: 'linear',
    duration: 200,
    opacity: 0,
    onComplete: () => {
      if (onComplete) {
        setTimeout(() => {
          // set to block
          hotspots.forEach((spot) => {
            spot.style.display = 'none';
          });
          onComplete();
        }, 300);
      }
    },
  });
};

const fadeIn = (hotspots, onComplete) => {
  if (!hotspots.length) {
    if (onComplete) onComplete();
    return;
  }
  animate(hotspots, {
    // autoplay: false,
    ease: 'outElastic(1, .6)',
    opacity: 1,
    translateY: [10, 0],
    // This stagger is unbounded - a month with a lot of hotspots can keep
    // isAnimating true for several seconds, which blocks both month clicks
    // (TimelineView.js) and filter checkboxes (FilterView.js's updateTags).
    // Rather than cap this (tried - a lot of hotspots popping in at once
    // read as abrupt/jarring) or silently drop the interrupting click,
    // useHotspotFilter.js registers a `settle` escape hatch on
    // AnimationContext: a click that lands mid-animation quickly resolves
    // the current fade to rest (SETTLE_DURATION in useHotspotFilter.js)
    // instead of waiting out however long this stagger would otherwise take.
    delay: stagger(150),
    onBegin: () => {
      // set to block
      hotspots.forEach((spot) => {
        spot.style.display = 'block';
      });
    },
    onComplete: () => {
      if (onComplete) {
        onComplete();
      }
    },
  });
};

const basicFadeOut = (hotspots, duration = 300, onComplete) => {
  if (!hotspots.length) {
    if (onComplete) onComplete();
    return;
  }
  animate(hotspots, {
    opacity: 0,
    ease: 'linear',
    duration,
    onComplete: () => {
      hotspots.forEach((spot) => {
        spot.style.display = 'none';
      });
      if (onComplete) onComplete();
    },
  });
};

const basicFadeIn = (hotspots, duration = 300, onComplete) => {
  if (!hotspots.length) {
    if (onComplete) onComplete();
    return;
  }
  animate(hotspots, {
    opacity: 1,
    ease: 'linear',
    duration,
    onBegin: () => {
      hotspots.forEach((spot) => {
        spot.style.display = 'block';
      });
    },
    onComplete: () => {
      if (onComplete) onComplete();
    },
  });
};

export { fadeIn, fadeOut, basicFadeIn, basicFadeOut };
